import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import SingleQTV from '@/features/buybox/components/list/SingleQTV.vue';
import { SportType } from '@/@types/graphql-types';

import type { SnowplowContext } from '@/helpers/tracking/providers';
import type { TitleDetail } from '@/interfaces/title-details-graphql';
import type { SportsTargetEvent } from '@/features/buybox/types/types';
import type { Maybe } from '@/helpers/types';

import { storeToRefs } from 'pinia';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import { useSportsSqtvCampaign } from '@/helpers/ad/useSportsSqtvTargeting';
import DisclaimerButton from '@/features/buybox/components/DisclaimerButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SportsSingleQTV',
  props: {
    title: null,
    additionalContexts: null,
    swiperIndex: null,
    displayPromotedTag: { type: Boolean, default: true }
  },
  emits: ["onPosterClickOut", "imageError", "onWatchNowClick"],
  setup(__props: any) {

const props = __props as { title: TitleDetail, additionalContexts: SnowplowContext[], swiperIndex?: number, displayPromotedTag: boolean };





const { country } = storeToRefs(useLanguageStore());
const { campaign, tags } = useSportsSqtvCampaign(country, () => props.title);

// Synthetic TitleDetail — sports fixtures have no real Movie/Show/Season node behind them, this is display-only.
const targetTitle = computed((): TitleDetail | null => {
	if (!campaign.value) return null;

	return {
		id: campaign.value.id,
		objectId: null,
		objectType: null,
		content: {
			title: campaign.value.title,
			posterUrl: campaign.value.posterUrl,
			backdrops: [{ backdropUrl: campaign.value.backdropUrl }],
			tags: [],
			genres: [],
			scoring: null,
		},
		offers: [],
		// Cast through unknown to bypass strict type checking — mirrors SponsoredRecommendationSingleQTV.vue
	} as unknown as TitleDetail;
});

const sportsTargetEvent = computed((): SportsTargetEvent | null => {
	if (!campaign.value) return null;

	return {
		sportType: campaign.value.sportType,
		offer: campaign.value.offer,
		sportObjectType: campaign.value.sportObjectType,
		competitionId: campaign.value.competitionId,
		seasonId: campaign.value.seasonId,
		eventId: campaign.value.eventId,
		venueId: campaign.value.venueId,
	};
});

return { __sfc: true,props, country, campaign, tags, targetTitle, sportsTargetEvent, SingleQTV, SportType, DisclaimerButton }
}

})